/**
 * Axios Request Wrapper
 * ---------------------
 */

import axios     from 'axios';
import constants from '../../shared/constants';
// import { getToken } from './auth';
// import React from 'react';
// import  { Redirect } from 'react-router-dom';


/**
 * Create an Axios Client with defaults
 */
const client = axios.create({
  baseURL: constants.auth0.baseUrl,
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
    'Access-Control-Allow-Methods': 'GET, PUT, POST, DELETE, OPTIONS'
  }
});

// request interceptor
client.interceptors.request.use(config => {
  // Do something before request is sent
  var accessToken =  localStorage.getItem("auth_tokenKey")
  if (accessToken) {
    config.headers['Authorization'] = 'Bearer ' + accessToken
  }
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

/**
 * Request Wrapper with default success/error actions
 */
const request = async function(options) {
  const onSuccess = function(response) {
    console.debug('Request Successful!', response);
    return response;
  }

  const onError = function(error) {
    // console.error('Request Failed:', error.config);

    console.log("onError: ");
    console.log(error);

    if (error.response) {
      // Request was made but server responded with something
      // other than 2xx
      switch(error.response.status) {
        case 401:
            console.log("teste 401");
            break;
            //return <Redirect to='/#/Login/'/>
            //this.props.history.push("/login");
            //break;
        default:
          // return error.response;
          break;
      }

      console.error('Status:',  error.response.status);
      console.error('Data:',    error.response.data);
      console.error('Headers:', error.response.headers);
    } else {
      // Something else happened while setting up the request
      // triggered the error
      console.error('Error Message:', error.message);
    }

    return Promise.reject(error.response || error.message);
  }

  try {
        const response = await client(options);
        return onSuccess(response);
    }
    catch (error) {
        return onError(error);
    }
}

export default request;